import { FileExtension, FileType } from 'common/files/files.enums';

export const DEFAULT_MAX_FILE_SIZE = 10 * 1024 * 1024;
export const INVALID_TYPE_ERROR_CODE = 'file-invalid-type';
export const FILE_TOO_LARGE_ERROR_CODE = 'file-too-large';
export const FILE_NUMBER_LIMIT = 5;
export const ALLOWED_EXTENSIONS = {
  [FileType.Png]: [`.${FileExtension.Png}`],
  [FileType.Jpeg]: [`.${FileExtension.Jpg}`, `.${FileExtension.Jpeg}`],
  [FileType.Pdf]: [`.${FileExtension.Pdf}`],
  [FileType.Doc]: [`.${FileExtension.Doc}`],
  [FileType.Docx]: [`.${FileExtension.Docx}`],
  [FileType.Xls]: [`.${FileExtension.Xls}`],
  [FileType.Xlsx]: [`.${FileExtension.Xlsx}`],
};
